import React, { Component } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { H, P, reset, buttonReset, FormGroup, Label, Hint, Textarea, Input, Modal, Button as Button$1, Select, Tabs, theme } from '@raketa-cms/raketa-mir';
export { FormGroup, Label, theme } from '@raketa-cms/raketa-mir';
import { ReactSortable } from 'react-sortablejs';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
var add = function add(items, item) {
  return [].concat(items, [item]);
};
var addAtBeggining = function addAtBeggining(items, item) {
  return [item].concat(items);
};
var removeByIndex = function removeByIndex(items, idx) {
  return [].concat(items.slice(0, idx), items.slice(idx + 1));
};
var removeById = function removeById(items, id, idField) {
  if (idField === void 0) {
    idField = 'id';
  }
  return removeByIndex(items, items.findIndex(function (current) {
    return current[idField] === id;
  }));
};
var updateFieldByIndex = function updateFieldByIndex(items, field, value, idx) {
  var _Object$assign;
  return [].concat(items.slice(0, idx), [Object.assign({}, items[idx], (_Object$assign = {}, _Object$assign[field] = value, _Object$assign))], items.slice(idx + 1));
};
var updateFieldById = function updateFieldById(items, field, value, id, idField) {
  if (idField === void 0) {
    idField = 'id';
  }
  return updateFieldByIndex(items, field, value, items.findIndex(function (current) {
    return current[idField] === id;
  }));
};
var randomId = function randomId() {
  return Math.floor(Math.random() * (999 - 100 + 1)) + 100;
};
var randomString = function randomString(length) {
  return Math.random().toString(36).substring(length);
};
var HostContext = /*#__PURE__*/React.createContext({});
var LibraryContext = /*#__PURE__*/React.createContext({});
var LibraryContext$1 = /*#__PURE__*/React.createContext(null);
var title = function title(widget) {
  if (widget.Config) {
    return widget.Config.title;
  } else {
    return widget.title;
  }
};
var adminFields = function adminFields(widget) {
  if (widget.Admin) {
    return widget.Admin;
  } else {
    return widget.adminFields;
  }
};
var category = function category(widget) {
  if (widget.Config) {
    return widget.Config.category;
  } else {
    return widget.category;
  }
};
var deprecated = function deprecated(widget) {
  if (widget.Config) {
    return widget.Config.deprecated;
  } else {
    return widget.deprecated;
  }
};
var primaryField = function primaryField(widget) {
  if (widget.Config) {
    return widget.Config.primaryField;
  } else {
    return widget.primaryField;
  }
};
var defaults = function defaults(widget) {
  if (widget.Defaults) {
    return widget.Defaults;
  } else {
    return widget.defaults;
  }
};
var widgetData = {
  title: title,
  adminFields: adminFields,
  category: category,
  deprecated: deprecated,
  defaults: defaults,
  primaryField: primaryField
};
function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  z-index: 9;\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var icons = {
  iconMove: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5tb3ZlPC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPjwvZGVmcz4gICAgPGcgaWQ9Im1vdmUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+ICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIiBpZD0iU2hhcGUiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8cG9seWxpbmUgcG9pbnRzPSIzIDcgMCAxMCAzIDEzIj48L3BvbHlsaW5lPiAgICAgICAgICAgIDxwb2x5bGluZSBwb2ludHM9IjcgMyAxMCAwIDEzIDMiPjwvcG9seWxpbmU+ICAgICAgICAgICAgPHBvbHlsaW5lIHBvaW50cz0iMTMgMTcgMTAgMjAgNyAxNyI+PC9wb2x5bGluZT4gICAgICAgICAgICA8cG9seWxpbmUgcG9pbnRzPSIxNyA3IDIwIDEwIDE3IDEzIj48L3BvbHlsaW5lPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDEwIEwyMCwxMCI+PC9wYXRoPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMCwwIEwxMCwyMCI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+',
  iconEdit: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5lZGl0LTI8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iZWRpdC0yIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDIuMDAwMDAwKSIgaWQ9IlNoYXBlIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+ICAgICAgICAgICAgPHBvbHlnb24gcG9pbnRzPSIxMyAwIDE4IDUgNSAxOCAwIDE4IDAgMTMiPjwvcG9seWdvbj4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==',
  iconDelete: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT50cmFzaDwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJ0cmFzaCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMDAwMDAwLCAxLjAwMDAwMCkiIGlkPSJTaGFwZSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiPiAgICAgICAgICAgIDxwb2x5bGluZSBwb2ludHM9IjAgNCAyIDQgMTggNCI+PC9wb2x5bGluZT4gICAgICAgICAgICA8cGF0aCBkPSJNMTYsNCBMMTYsMTggQzE2LDE5LjEwNDU2OTUgMTUuMTA0NTY5NSwyMCAxNCwyMCBMNCwyMCBDMi44OTU0MzA1LDIwIDIsMTkuMTA0NTY5NSAyLDE4IEwyLDQgTTUsNCBMNSwyIEM1LDAuODk1NDMwNSA1Ljg5NTQzMDUsMCA3LDAgTDExLDAgQzEyLjEwNDU2OTUsMCAxMywwLjg5NTQzMDUgMTMsMiBMMTMsNCI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+',
  iconCopy: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItY29weSI+PHJlY3QgeD0iOSIgeT0iOSIgd2lkdGg9IjEzIiBoZWlnaHQ9IjEzIiByeD0iMiIgcnk9IjIiPjwvcmVjdD48cGF0aCBkPSJNNSAxNUg0YTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDlhMiAyIDAgMCAxIDIgMnYxIj48L3BhdGg+PC9zdmc+'
};
var colors = {
  primary: 'rgb(0,102,221)',
  secondary: '#000',
  danger: '#d00',
  neutral: '#fff'
};
var IconButton = function IconButton(props) {
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    style: {
      display: 'inline-block',
      width: '32px',
      height: '32px',
      marginRight: '4px',
      marginLeft: props.type === 'neutral' ? '32px' : 0,
      appearance: 'none',
      outline: '0',
      border: '0',
      borderRadius: '3px',
      background: 'transparent',
      backgroundColor: colors[props.type] || '#000',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '50%',
      backgroundImage: "url(" + icons[props.icon] + ")",
      cursor: 'pointer'
    }
  }, props));
};
var AdminWidgetWrapper = styled.div(_templateObject(), function (props) {
  return "\n    &:hover {\n      position: relative;\n      box-shadow: inset 0 0 0 1px " + props.theme.colors.gray + ";\n\n      & > div[data-toolbar] { display: flex; }\n    }\n  ";
});
var AdminWidgetToolbar = styled.div(_templateObject2(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.font.base;
});
var AdminWidget = function AdminWidget(_ref) {
  var library = _ref.library,
    adminLibrary = _ref.adminLibrary,
    identifier = _ref.identifier,
    widget = _ref.widget,
    onEdit = _ref.onEdit,
    onDelete = _ref.onDelete;
  var currentWidget = library[widget.component];
  var currentAdminWidget = adminLibrary[widget.component];
  if (!currentWidget || !currentAdminWidget) {
    console.error("Unknown widget: " + widget.component);
    return null;
  }
  var handleDeleteWidget = function handleDeleteWidget() {
    if (!confirm('Are you sure?')) return;
    onDelete(widget.widgetId);
  };
  var handleCopyWidget = function handleCopyWidget() {
    var storedWidget = JSON.stringify({
      widgetName: widget.component,
      widget: widget
    });
    window.localStorage.setItem("clipboard\u2013" + identifier, storedWidget);
  };
  return /*#__PURE__*/React.createElement(AdminWidgetWrapper, null, /*#__PURE__*/React.createElement(AdminWidgetToolbar, {
    "data-toolbar": true
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: "iconMove",
    "data-drag": true
  }), /*#__PURE__*/React.createElement(IconButton, {
    icon: "iconEdit",
    type: "primary",
    onClick: function onClick() {
      return onEdit(widget);
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    icon: "iconDelete",
    type: "danger",
    onClick: function onClick() {
      return handleDeleteWidget();
    }
  }), !widgetData.deprecated(currentAdminWidget) && /*#__PURE__*/React.createElement(IconButton, {
    icon: "iconCopy",
    type: "neutral",
    onClick: handleCopyWidget
  })), /*#__PURE__*/React.createElement(currentWidget, widget.settings));
};
AdminWidget.defaultProps = {
  containerSettings: {}
};
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ErrorBoundary, _Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      hasError: true
    };
  };
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, info) {
    console.error(error, info);
  };
  _proto.render = function render() {
    if (this.state.hasError) return null;
    return this.props.children;
  };
  return ErrorBoundary;
}(Component);
function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n"]);
  _templateObject$1 = function _templateObject() {
    return data;
  };
  return data;
}
var EmptyCanvas = styled.div(_templateObject$1());
var Canvas = /*#__PURE__*/React.memo(function (_ref) {
  var widgets = _ref.widgets,
    onReorder = _ref.onReorder,
    onEdit = _ref.onEdit,
    onRemove = _ref.onRemove,
    identifier = _ref.identifier;
  var _React$useContext = React.useContext(LibraryContext),
    library = _React$useContext.library,
    adminLibrary = _React$useContext.adminLibrary;
  if (widgets.length === 0) {
    return /*#__PURE__*/React.createElement(EmptyCanvas, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H, {
      size: "xxlarge"
    }, "It's always good to start with a clean slate."), /*#__PURE__*/React.createElement(P, null, "Use the sidebar to add content.")));
  }
  return /*#__PURE__*/React.createElement(ReactSortable, {
    list: widgets,
    setList: onReorder,
    handle: "[data-drag]",
    direction: "horizontal",
    dragoverBubble: true
  }, widgets.map(function (widget) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      key: widget.widgetId
    }, /*#__PURE__*/React.createElement(AdminWidget, {
      library: library,
      adminLibrary: adminLibrary,
      identifier: identifier,
      widget: widget,
      onEdit: onEdit,
      onDelete: onRemove
    }));
  }));
}, function (props, nextProps) {
  var themesAreEqual = JSON.stringify(props.themes) === JSON.stringify(nextProps.themes);
  var spacingsAreEqual = JSON.stringify(props.spacings) === JSON.stringify(nextProps.spacings);
  var widgetsAreEqual = JSON.stringify(props.widgets) === JSON.stringify(nextProps.widgets);
  return themesAreEqual && spacingsAreEqual && widgetsAreEqual;
});
function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: ", ";\n  margin-bottom: ", ";\n\n  input:not([type]) {\n    position: absolute;\n    top: 0;\n    right: ", ";\n    left: ", ";\n    bottom: 0;\n    width: 125%;\n    padding-left: ", ";\n    padding-right: ", ";\n    font-size: ", ";\n    border: 0 !important;\n    border-radius: 0;\n    background-color: ", ";\n    color: ", ";\n  }\n"]);
  _templateObject10 = function _templateObject10() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  display: block;\n  width: 100%;\n  padding-bottom: ", ";\n  margin-bottom: ", ";\n  font-size: ", ";\n  font-weight: 300;\n  text-align: left;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    padding-left: ", ";\n  }\n"]);
  _templateObject9 = function _templateObject9() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"]);
  _templateObject8 = function _templateObject8() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: none;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 64px;\n  width: 300px;\n  padding: ", ";\n  background-color: rgba(0, 0, 0, 0.9);\n  color: ", ";\n  backdrop-filter: blur(8px);\n  overflow-y: auto;\n  z-index: 11;\n"]);
  _templateObject7 = function _templateObject7() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: absolute;\n  top: calc(50% - 1em);\n  left: 72px;\n  z-index: 1001;\n  height: 2em;\n  padding: 0.5em 0.75em;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: ", ";\n  line-height: 1;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s ease-in-out;\n"]);
  _templateObject6 = function _templateObject6() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  &:hover {\n    .cms-tooltip {\n      opacity: 1;\n    }\n  }\n"]);
  _templateObject5 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  position: relative;\n  z-index: 1000;\n  display: block;\n  font-size: ", ";\n  color: ", ";\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: ", ";\n  ", "\n  width: 64px;\n  height: 64px;\n  border-bottom: 1px solid ", ";\n  z-index: 12;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    opacity: 0.9;\n  }\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 10;\n\n  &:hover > * {\n    display: block;\n  }\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n"]);
  _templateObject2$1 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 64px;\n  background-color: ", ";\n  border-right: 1px solid ", ";\n  z-index: 30;\n"]);
  _templateObject$2 = function _templateObject() {
    return data;
  };
  return data;
}
var SideNav = styled.div(_templateObject$2(), reset, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.darkerGray;
});
var NavGroup = styled.div(_templateObject2$1(), reset);
var NavItem = styled.div(_templateObject3());
var NavButtonStyle = styled.button(_templateObject4(), reset, buttonReset, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.active ? props.theme.colors.darkerGray : props.success ? props.theme.colors.success : 'transparent';
}, function (props) {
  return props.icon ? "background-image: url(\"" + props.icon + "\");" : '';
}, function (props) {
  return props.theme.colors.darkerGray;
}, function (props) {
  return props.success ? props.theme.colors.success : props.theme.colors.darkerGray;
});
var TooltipWrapper = styled.div(_templateObject5());
var Tooltip = styled.div(_templateObject6(), reset, function (props) {
  return props.theme.colors.white;
});
var NavButton = function NavButton(_ref) {
  var tooltip = _ref.tooltip,
    props = _objectWithoutPropertiesLoose(_ref, ["tooltip"]);
  return /*#__PURE__*/React.createElement(TooltipWrapper, null, /*#__PURE__*/React.createElement(NavButtonStyle, props), tooltip && /*#__PURE__*/React.createElement(Tooltip, {
    className: "cms-tooltip"
  }, tooltip));
};
var NavPanel = styled.div(_templateObject7(), reset, function (props) {
  return "calc(" + props.theme.font.base + " * 2)";
}, function (props) {
  return props.theme.colors.white;
});
var NavSectionMenu = styled.div(_templateObject8());
var NavSectionMenuItem = styled.button(_templateObject9(), reset, buttonReset, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.darkerGray;
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
});
var SideNavSearchWrapper = styled.div(_templateObject10(), function (props) {
  return "calc(" + props.theme.font.base + " * 3.125)";
}, function (props) {
  return props.theme.font.base;
}, function (props) {
  return "calc(" + props.theme.font.base + " * -2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " * -2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " * 2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " * 2)";
}, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.white;
});
function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: relative;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  cursor: pointer;\n"]);
  _templateObject5$1 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: relative;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  text-transform: uppercase;\n\n  span {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    opacity: 0.6;\n\n    color: ", ";\n    font-weight: 700;\n    font-size: ", ";\n    text-decoration: none;\n  }\n\n  a {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 3;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    color: ", ";\n    font-weight: 700;\n    font-size: ", ";\n    text-decoration: none;\n\n    :hover {\n      background-color: ", ";\n    }\n  }\n"]);
  _templateObject4$1 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  text-transform: uppercase;\n\n  a {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    color: ", ";\n    font-weight: 700;\n    font-size: ", ";\n    text-decoration: none;\n\n    :hover {\n      background-color: ", ";\n    }\n  }\n"]);
  _templateObject3$1 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: absolute;\n  z-index: 9;\n  left: -1000px;\n  display: flex;\n  flex-wrap: nowrap;\n  height: 100%;\n  background-color: ", ";\n  opacity: 0;\n  transition: all ease-in-out 0.3s;\n"]);
  _templateObject2$2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  width: ", ";\n  height: ", ";\n  color: #fff;\n\n  &:hover {\n    [data-switcher] {\n      left: ", ";\n      top: 0;\n      opacity: 1;\n    }\n  }\n"]);
  _templateObject$3 = function _templateObject() {
    return data;
  };
  return data;
}
var SIZE = '64px';
var LanguageSwitcherWrapper = styled.div(_templateObject$3(), reset, SIZE, SIZE, SIZE);
var LanguageSwitcherMenu = styled.div(_templateObject2$2(), reset, function (props) {
  return props.theme.colors.trueBlack;
});
var LanguageSwitcherItem = styled.div(_templateObject3$1(), reset, SIZE, SIZE, function (props) {
  return props.theme.colors.trueBlack;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.primaryRGB06;
});
var LanguageSwitcherNewItem = styled.div(_templateObject4$1(), reset, SIZE, SIZE, function (props) {
  return props.theme.colors.trueBlack;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.font.medium;
}, function (props) {
  return props.theme.colors.primaryRGB06;
});
var LanguageSwitcherCurrent = styled.div(_templateObject5$1(), reset, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.font.medium;
});
var LanguageSwitcherItemComponent = function LanguageSwitcherItemComponent(_ref) {
  var path = _ref.path,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(LanguageSwitcherItem, null, /*#__PURE__*/React.createElement("a", {
    href: path
  }, label));
};
var LanguageSwitcherNewItemComponent = function LanguageSwitcherNewItemComponent(_ref2) {
  var path = _ref2.path,
    label = _ref2.label;
  return /*#__PURE__*/React.createElement(LanguageSwitcherNewItem, null, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("a", {
    href: path
  }, "+"));
};
var LanguageSwitcher = function LanguageSwitcher(_ref3) {
  var current = _ref3.current,
    navigation = _ref3.navigation;
  return /*#__PURE__*/React.createElement(LanguageSwitcherWrapper, null, /*#__PURE__*/React.createElement(LanguageSwitcherCurrent, null, current), /*#__PURE__*/React.createElement(LanguageSwitcherMenu, {
    "data-switcher": true
  }, navigation.map(function (navItem, idx) {
    var LinkComponent = navItem.newItem ? LanguageSwitcherNewItemComponent : LanguageSwitcherItemComponent;
    return /*#__PURE__*/React.createElement(LinkComponent, {
      key: idx,
      path: navItem.path,
      label: navItem.label
    });
  })));
};
function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  position: relative;\n  background-color: transparent;\n  width: 100%;\n  padding: 0;\n  margin-bottom: ", ";\n  font-size: ", ";\n  color: #999;\n  text-align: left;\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    color: ", ";\n  }\n"]);
  _templateObject$4 = function _templateObject() {
    return data;
  };
  return data;
}
var SidebarItem = styled.button(_templateObject$4(), reset, buttonReset, function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.colors.white;
});
var TextField = function TextField(_ref) {
  var label = _ref.label,
    hint = _ref.hint,
    multiline = _ref.multiline,
    error = _ref.error,
    _onChange = _ref.onChange,
    rest = _objectWithoutPropertiesLoose(_ref, ["label", "hint", "multiline", "error", "onChange"]);
  var id = randomString();
  var Component = multiline ? Textarea : Input;
  return /*#__PURE__*/React.createElement(FormGroup, null, label ? /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    error: error
  }, label) : '', /*#__PURE__*/React.createElement(Component, _extends({
    id: id,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, rest)), hint ? /*#__PURE__*/React.createElement(Hint, null, hint) : '');
};
var TextInput = function TextInput(props) {
  return /*#__PURE__*/React.createElement(TextField, props);
};
TextInput.defaultProps = {
  value: '',
  placeholder: ''
};
var ICONS = {
  add: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5wbHVzLWNpcmNsZTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJwbHVzLWNpcmNsZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAxLjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiPjwvY2lyY2xlPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMCw2IEwxMCwxNCIgaWQ9IlNoYXBlIj48L3BhdGg+ICAgICAgICAgICAgPHBhdGggZD0iTTYsMTAgTDE0LDEwIiBpZD0iU2hhcGUiPjwvcGF0aD4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==',
  reorder: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5saXN0PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPjwvZGVmcz4gICAgPGcgaWQ9Imxpc3QiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4wMDAwMDAsIDUuMDAwMDAwKSIgaWQ9IlNoYXBlIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8cGF0aCBkPSJNMCwwIEwxMywwIj48L3BhdGg+ICAgICAgICAgICAgPHBhdGggZD0iTTAsNiBMMTMsNiI+PC9wYXRoPiAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDEyIEwxMywxMiI+PC9wYXRoPiAgICAgICAgPC9nPiAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC0yIiBmaWxsPSIjRkZGRkZGIiBjeD0iMyIgY3k9IjUiIHI9IjEiPjwvY2lyY2xlPiAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC0yIiBmaWxsPSIjRkZGRkZGIiBjeD0iMyIgY3k9IjE3IiByPSIxIj48L2NpcmNsZT4gICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwtMiIgZmlsbD0iI0ZGRkZGRiIgY3g9IjMiIGN5PSIxMSIgcj0iMSI+PC9jaXJjbGU+ICAgIDwvZz48L3N2Zz4=',
  save: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5jaGVjazwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJjaGVjayIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMuMDAwMDAwLCA2LjAwMDAwMCkiIGlkPSJTaGFwZSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiPiAgICAgICAgICAgIDxwb2x5bGluZSBwb2ludHM9IjE2IDAgNSAxMSAwIDYiPjwvcG9seWxpbmU+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=',
  paste: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxOHB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAxOCAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5jbGlwYm9hcmQ8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIGlkPSJjbGlwYm9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAxLjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8ZyBpZD0iY2xpcGJvYXJkLXdoaXRlIj4gICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLDIgTDE0LDIgQzE1LjEwNDU2OTUsMiAxNiwyLjg5NTQzMDUgMTYsNCBMMTYsMTggQzE2LDE5LjEwNDU2OTUgMTUuMTA0NTY5NSwyMCAxNCwyMCBMMiwyMCBDMC44OTU0MzA1LDIwIDAsMTkuMTA0NTY5NSAwLDE4IEwwLDQgQzAsMi44OTU0MzA1IDAuODk1NDMwNSwyIDIsMiBMNCwyIiBpZD0iUGF0aCI+PC9wYXRoPiAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSI0IiB5PSIwIiB3aWR0aD0iOCIgaGVpZ2h0PSI0IiByeD0iMSI+PC9yZWN0PiAgICAgICAgICAgIDwvZz4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==',
  exit: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCAyMiAyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5jaGV2cm9ucy1sZWZ0PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPjwvZGVmcz4gICAgPGcgaWQ9ImNoZXZyb25zLWxlZnQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+ICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LjAwMDAwMCwgNi4wMDAwMDApIiBpZD0iU2hhcGUiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8cG9seWxpbmUgcG9pbnRzPSI1IDEwIDAgNSA1IDAiPjwvcG9seWxpbmU+ICAgICAgICAgICAgPHBvbHlsaW5lIHBvaW50cz0iMTIgMTAgNyA1IDEyIDAiPjwvcG9seWxpbmU+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=',
  settings: 'data:image/svg+xml;base64,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',
  publish: 'data:image/svg+xml;base64,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'
};
var sortByTitle = function sortByTitle(a, b) {
  var nameA = a.widgetTitle.toUpperCase();
  var nameB = b.widgetTitle.toUpperCase();
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};
var WidgetsList = function WidgetsList(_ref) {
  var library = _ref.library,
    onAddWidget = _ref.onAddWidget;
  var _React$useState = React.useState(''),
    q = _React$useState[0],
    setQ = _React$useState[1];
  var widgets = Object.keys(library).filter(function (widgetName) {
    return !widgetData.deprecated(library[widgetName]);
  }).filter(function (widgetName) {
    return widgetData.title(library[widgetName]).toLowerCase().indexOf(q.toLowerCase()) !== -1;
  });
  var widgetsCategories = widgets.map(function (widgetName) {
    return widgetData.category(library[widgetName]);
  }).filter(function (c, idx, self) {
    return self.indexOf(c) === idx;
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SideNavSearchWrapper, null, /*#__PURE__*/React.createElement(TextInput, {
    value: q,
    onChange: setQ,
    placeholder: "Search..."
  })), widgetsCategories.map(function (categoryName, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      style: {
        marginBottom: '25px'
      }
    }, /*#__PURE__*/React.createElement(H, {
      size: "medium",
      style: {
        color: '#fff'
      }
    }, categoryName), widgets.filter(function (widgetName) {
      return widgetData.category(library[widgetName]) === categoryName;
    }).map(function (widgetName) {
      return {
        widgetName: widgetName,
        widgetTitle: widgetData.title(library[widgetName])
      };
    }).sort(sortByTitle).map(function (item, idx) {
      return /*#__PURE__*/React.createElement(SidebarItem, {
        key: idx,
        onClick: function onClick() {
          return onAddWidget(item.widgetName);
        }
      }, item.widgetTitle);
    }));
  }));
};
var AdminSidebar = function AdminSidebar(_ref2) {
  var dirty = _ref2.dirty,
    buttons = _ref2.buttons,
    languageSwitcherSettings = _ref2.languageSwitcherSettings,
    onAddWidget = _ref2.onAddWidget,
    onReorderDialog = _ref2.onReorderDialog,
    onPasteWidget = _ref2.onPasteWidget,
    onSave = _ref2.onSave,
    onExit = _ref2.onExit;
  var _React$useContext = React.useContext(LibraryContext),
    adminLibrary = _React$useContext.adminLibrary;
  return /*#__PURE__*/React.createElement(SideNav, null, /*#__PURE__*/React.createElement(NavGroup, null, /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    icon: ICONS.add
  }), /*#__PURE__*/React.createElement(NavPanel, null, /*#__PURE__*/React.createElement(H, {
    size: "large",
    style: {
      color: '#fff'
    }
  }, "Library"), /*#__PURE__*/React.createElement(WidgetsList, {
    library: adminLibrary,
    onAddWidget: onAddWidget
  }))), /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    tooltip: "Reorder widgets",
    icon: ICONS.reorder,
    onClick: onReorderDialog
  })), /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    tooltip: "Save page",
    icon: ICONS.save,
    success: dirty,
    onClick: onSave
  })), /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    tooltip: "Paste widget",
    icon: ICONS.paste,
    onClick: onPasteWidget
  })), buttons && buttons.map(function (button) {
    return /*#__PURE__*/React.createElement(NavItem, {
      key: button.id
    }, /*#__PURE__*/React.createElement(NavButton, {
      id: button.id,
      tooltip: button.label,
      className: button.className,
      icon: ICONS[button.icon],
      onClick: function onClick() {
        return button.onClick();
      }
    }, ICONS[button.icon] ? '' : button.label));
  })), /*#__PURE__*/React.createElement(NavGroup, null, languageSwitcherSettings && /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(LanguageSwitcher, languageSwitcherSettings)), /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavButton, {
    tooltip: "Exit",
    icon: ICONS.exit,
    onClick: onExit
  }))));
};
function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: ", ";\n  border-top: 2px solid ", ";\n"]);
  _templateObject2$3 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  max-height: 75vh;\n  overflow-y: auto;\n"]);
  _templateObject$5 = function _templateObject() {
    return data;
  };
  return data;
}
var ModalContent = styled.div(_templateObject$5());
var ModalFooter = styled.div(_templateObject2$3(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.colors.lightGray;
});
var Dialog = function Dialog(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    title = _ref.title,
    children = _ref.children,
    primaryLabel = _ref.primaryLabel,
    _ref$secondaryLabel = _ref.secondaryLabel,
    secondaryLabel = _ref$secondaryLabel === void 0 ? 'Cancel' : _ref$secondaryLabel,
    onPrimary = _ref.onPrimary;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    title: title,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(ModalContent, null, children), (primaryLabel || secondaryLabel) && /*#__PURE__*/React.createElement(ModalFooter, null, primaryLabel && /*#__PURE__*/React.createElement(Button$1, {
    type: "button",
    variant: "primary",
    onClick: onPrimary
  }, primaryLabel), secondaryLabel && /*#__PURE__*/React.createElement(Button$1, {
    type: "button",
    variant: "secondary",
    onClick: onClose
  }, secondaryLabel)));
};
Dialog.defaultProps = {
  children: []
};
function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", ";\n  margin-bottom: ", ";\n  border: 1px solid ", ";\n  border-radius: 3px;\n  color: ", ";\n  cursor: move;\n\n  h6 {\n    margin-bottom: 0;\n    margin-left: ", ";\n  }\n"]);
  _templateObject$6 = function _templateObject() {
    return data;
  };
  return data;
}
var ReorderDialogItem = styled.div(_templateObject$6(), function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
});
var cleanup = function cleanup(string) {
  return string.replace(/<[^>]*>?/gm, '');
};
var truncate = function truncate(str, num) {
  if (str.length <= num) return str;
  return str.slice(0, num) + '…';
};
var getWidgetTitle = function getWidgetTitle(library, widget) {
  var widgetComponent = library[widget.component];
  if (!widgetComponent) {
    console.error("Unknown widget: " + widget.component);
    return "Unknown widget: " + widget.component;
  }
  var widgetName = widgetData.title(widgetComponent) || widget.component;
  var primaryField = widgetData.primaryField(widgetComponent) && widget.settings[widgetData.primaryField(widgetComponent)];
  if (primaryField && typeof primaryField !== 'string') {
    throw new Error("The primaryField value of '" + widget.component + "' must be either a string or not present!");
  }
  var widgetTitle = primaryField ? truncate(cleanup(primaryField), 32) : '';
  return [widgetName, widgetTitle].filter(function (s) {
    return s !== '';
  }).join(': ');
};
var ReorderDialog = function ReorderDialog(_ref) {
  var widgets = _ref.widgets,
    onClose = _ref.onClose,
    onChange = _ref.onChange,
    onDelete = _ref.onDelete,
    onSelectWidget = _ref.onSelectWidget;
  var _React$useContext = React.useContext(LibraryContext),
    adminLibrary = _React$useContext.adminLibrary;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    onClose: onClose,
    title: "Reorder",
    primaryLabel: "",
    secondaryLabel: "Close"
  }, /*#__PURE__*/React.createElement(P, null, "Drag and drop elements below to reorder the page layout."), /*#__PURE__*/React.createElement(ReactSortable, {
    list: widgets,
    setList: onChange,
    handle: "[data-drag]",
    direction: "horizontal",
    dragoverBubble: true
  }, widgets.map(function (widget) {
    return /*#__PURE__*/React.createElement("div", {
      key: widget.widgetId
    }, /*#__PURE__*/React.createElement(ReorderDialogItem, {
      "data-drag": true
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(H, {
      size: "base",
      style: {
        paddingBottom: 0,
        fontWeight: 500
      }
    }, getWidgetTitle(adminLibrary, widget))), /*#__PURE__*/React.createElement("div", null, adminLibrary[widget.component] && /*#__PURE__*/React.createElement(Button$1, {
      type: "button",
      variant: "primary",
      onClick: function onClick() {
        onClose();
        onSelectWidget(widget);
      }
    }, "Edit"), /*#__PURE__*/React.createElement(Button$1, {
      type: "button",
      variant: "danger",
      onClick: function onClick() {
        if (!confirm('Are you sure?')) return;
        onDelete(widget.widgetId);
      }
    }, "\xD7"))));
  })));
};
ReorderDialog.defaultProps = {
  widgets: []
};
var TextArea = function TextArea(props) {
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    multiline: true
  }, props));
};
TextArea.defaultProps = {
  value: '',
  placeholder: ''
};
var RichText = function () {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "RichText is no longer part of @raketa-cms/raketa-cms. Please use @raketa-cms/raketa-rte"), /*#__PURE__*/React.createElement("strong", null, "Update your imports"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "import {RichText} from '@raketa-cms/raketa-rte';")), /*#__PURE__*/React.createElement("strong", null, "Update usage in JSON adminFields"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "text: { type: 'custom', component: RichText },")));
};
var getOptions = function getOptions(options, placeholder) {
  var initialOptions = placeholder ? [{
    value: '',
    text: placeholder
  }] : [];
  var preparedOptions = options.map(function (o) {
    return {
      value: o[0],
      text: o[1]
    };
  });
  return [].concat(initialOptions, preparedOptions);
};
var SelectField = function SelectField(props) {
  var id = randomString();
  var label = props.label,
    hint = props.hint,
    options = props.options,
    placeholder = props.placeholder,
    _onChange = props.onChange;
  var inputProps = Object.assign({}, props);
  delete inputProps.label;
  delete inputProps.hint;
  delete inputProps.options;
  delete inputProps.placeholder;
  delete inputProps.onChange;
  return /*#__PURE__*/React.createElement(FormGroup, null, label ? /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    error: props.error
  }, label) : '', /*#__PURE__*/React.createElement(Select, _extends({
    id: id,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, inputProps), placeholder ? /*#__PURE__*/React.createElement("option", {
    key: "placeholder",
    value: null
  }, placeholder) : '', options.map(function (o) {
    return /*#__PURE__*/React.createElement("option", {
      key: o.value,
      value: o.value
    }, o.text);
  })), hint ? /*#__PURE__*/React.createElement(Hint, null, hint) : '');
};
var SelectMenu = function SelectMenu(_ref) {
  var label = _ref.label,
    options = _ref.options,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(SelectField, {
    label: label,
    options: getOptions(options, placeholder),
    value: value,
    onChange: onChange
  });
};
SelectMenu.defaultProps = {
  value: '',
  placeholder: 'Please select...'
};
function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  margin-bottom: 0;\n\n  & + div {\n    margin-top: ", ";\n  }\n"]);
  _templateObject4$2 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: ", ";\n  font-size: ", ";\n  text-transform: uppercase;\n  font-weight: bold;\n"]);
  _templateObject3$2 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n\n  & > div {\n    width: 33.33%;\n    padding-right: ", ";\n\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n\n  &:last-child {\n    & > div {\n      margin-bottom: 0;\n    }\n  }\n"]);
  _templateObject2$4 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  margin-right: ", ";\n  background-size: 100% auto;\n  background-repeat: none;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItc2xpZGVycyI+PGxpbmUgeDE9IjQiIHkxPSIyMSIgeDI9IjQiIHkyPSIxNCI+PC9saW5lPjxsaW5lIHgxPSI0IiB5MT0iMTAiIHgyPSI0IiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjIxIiB4Mj0iMTIiIHkyPSIxMiI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjgiIHgyPSIxMiIgeTI9IjMiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIyMSIgeDI9IjIwIiB5Mj0iMTYiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIxMiIgeDI9IjIwIiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxIiB5MT0iMTQiIHgyPSI3IiB5Mj0iMTQiPjwvbGluZT48bGluZSB4MT0iOSIgeTE9IjgiIHgyPSIxNSIgeTI9IjgiPjwvbGluZT48bGluZSB4MT0iMTciIHkxPSIxNiIgeDI9IjIzIiB5Mj0iMTYiPjwvbGluZT48L3N2Zz4=);\n}"]);
  _templateObject$7 = function _templateObject() {
    return data;
  };
  return data;
}
var SettingsIcon = styled.span(_templateObject$7(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.font.base;
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
});
var ThreeColumns = styled.div(_templateObject2$4(), reset, function (props) {
  return props.theme.font.base;
});
var FormSectionTitle = styled.h6(_templateObject3$2(), reset, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return props.theme.font.small;
});
var ButtonControl = styled.div(_templateObject4$2(), reset, function (props) {
  return props.theme.font.base;
});
var DEFAULT_BUTTON_STYLES = [['primary', 'Primary'], ['secondary', 'Secondary'], ['text', 'Text']];
var mergeSettings = function mergeSettings(settings, key, value) {
  var _Object$assign;
  return Object.assign({}, settings, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
};
var ButtonSettings = function ButtonSettings(_ref) {
  var label = _ref.label,
    hint = _ref.hint,
    value = _ref.value,
    _onChange = _ref.onChange;
  var buttonStyles = React.useContext(LibraryContext$1) || DEFAULT_BUTTON_STYLES;
  return /*#__PURE__*/React.createElement(ButtonControl, null, /*#__PURE__*/React.createElement(FormSectionTitle, null, /*#__PURE__*/React.createElement(SettingsIcon, null), " ", label), /*#__PURE__*/React.createElement(ThreeColumns, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: value.label,
    onChange: function onChange(label) {
      return _onChange(mergeSettings(value, 'label', label));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Link",
    value: value.link,
    onChange: function onChange(link) {
      return _onChange(mergeSettings(value, 'link', link));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "ID",
    value: value.id,
    onChange: function onChange(id) {
      return _onChange(mergeSettings(value, 'id', id));
    }
  })), /*#__PURE__*/React.createElement(ThreeColumns, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Type",
    options: buttonStyles,
    value: value.type,
    placeholder: "",
    onChange: function onChange(type) {
      return _onChange(mergeSettings(value, 'type', type));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Target",
    options: [['_self', 'Self'], ['_blank', 'New Tab']],
    value: value.target,
    onChange: function onChange(target) {
      return _onChange(mergeSettings(value, 'target', target));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Follow Link",
    options: [['follow', 'Follow'], ['nofollow', 'No Follow']],
    value: value.rel,
    onChange: function onChange(rel) {
      return _onChange(mergeSettings(value, 'rel', rel));
    }
  })), hint ? /*#__PURE__*/React.createElement(Hint, null, hint) : '');
};
var DEFAULTS = {
  label: 'Button',
  link: '#',
  id: '',
  type: 'primary',
  target: '_self',
  rel: 'follow'
};
ButtonSettings.defaultProps = {
  label: 'Button',
  value: DEFAULTS
};
ButtonSettings.defaults = DEFAULTS;
ButtonSettings.defaultButtonStyles = DEFAULT_BUTTON_STYLES;
var toUnderscore = function toUnderscore(string) {
  return string.replace(/([A-Z])/g, function ($1) {
    return "_" + $1.toLowerCase();
  });
};
var humanize = function humanize(string) {
  return toUnderscore(string).replace(/_/g, ' ');
};
var capitalize = function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};
var ImagePicker = function () {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "ImagePicker is no longer part of @raketa-cms/raketa-cms. Please use @raketa-cms/raketa-image-input.", ' '), /*#__PURE__*/React.createElement("strong", null, "Update imports"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "import { ImagePicker } from '@raketa-cms/raketa-image-picker';")), /*#__PURE__*/React.createElement("strong", null, "Update JSON adminFields"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "image: { type: 'custom', component: ImagePicker },")));
};
function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n"]);
  _templateObject2$5 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  gap: 0.5em;\n  justify-content: space-between;\n"]);
  _templateObject$8 = function _templateObject() {
    return data;
  };
  return data;
}
var SegmentWrapper = styled.div(_templateObject$8());
var Segment = styled.div(_templateObject2$5());
var renderField = function renderField(field, value, onChange, opts) {
  var handleChange = function handleChange(newValue) {
    return onChange(field, newValue);
  };
  switch (opts.type) {
    case 'text':
      {
        return /*#__PURE__*/React.createElement(TextInput, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }
    case 'textarea':
      {
        return /*#__PURE__*/React.createElement(TextArea, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }
    case 'rich':
      {
        return /*#__PURE__*/React.createElement(RichText, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }
    case 'select':
      {
        return /*#__PURE__*/React.createElement(SelectMenu, _extends({
          key: "dialog-" + field,
          label: opts.label,
          options: opts.options,
          value: value,
          onChange: handleChange
        }, opts));
      }
    case 'image':
      {
        return /*#__PURE__*/React.createElement(ImagePicker, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }
    case 'button':
      {
        return /*#__PURE__*/React.createElement(ButtonSettings, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }
    case 'custom':
      {
        var Component = opts.component;
        return /*#__PURE__*/React.createElement(Component, _extends({
          key: "dialog-" + field,
          label: opts.label,
          value: value,
          onChange: handleChange
        }, opts));
      }
    default:
      {
        return /*#__PURE__*/React.createElement(TextInput, {
          key: "dialog-" + field,
          label: field,
          value: value,
          onChange: handleChange
        });
      }
  }
};
var renderAdminFields = function renderAdminFields(widget, settings, onChange) {
  return Object.keys(widgetData.adminFields(widget)).map(function (field) {
    var opts = Object.assign({
      label: capitalize(humanize(field))
    }, widgetData.adminFields(widget)[field]);
    return renderField(field, settings[field], onChange, opts);
  });
};
var SettingsDialog = function SettingsDialog(_ref) {
  var spacings = _ref.spacings,
    themes = _ref.themes,
    widget = _ref.widget,
    settings = _ref.settings,
    onSave = _ref.onSave,
    onClose = _ref.onClose;
  var _React$useState = React.useState(settings),
    localSettings = _React$useState[0],
    setLocalSettings = _React$useState[1];
  var handleChangeField = function handleChangeField(field, value) {
    var _extends2;
    setLocalSettings(_extends({}, localSettings, (_extends2 = {}, _extends2[field] = value, _extends2)));
  };
  var handleUpdateLayoutSettings = function handleUpdateLayoutSettings(field, value) {
    var _extends3;
    handleChangeField('containerSettings', _extends({}, localSettings.containerSettings, (_extends3 = {}, _extends3[field] = value, _extends3)));
  };
  var fields;
  if (typeof widgetData.adminFields(widget) === 'object') {
    fields = renderAdminFields(widget, localSettings, handleChangeField);
  }
  if (typeof widgetData.adminFields(widget) === 'function') {
    var items = localSettings.list ? localSettings.list : [];
    fields = widgetData.adminFields(widget)(items, handleChangeField, localSettings);
  }
  var _localSettings$contai = localSettings.containerSettings,
    containerSettings = _localSettings$contai === void 0 ? {} : _localSettings$contai;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    title: widgetData.title(widget),
    primaryLabel: "OK",
    width: "700px",
    onPrimary: function onPrimary() {
      return onSave(localSettings);
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement("div", {
    title: "Content"
  }, fields), /*#__PURE__*/React.createElement("div", {
    title: "Settings"
  }, /*#__PURE__*/React.createElement(SegmentWrapper, null, /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Spacing",
    options: spacings,
    value: containerSettings.spacing || '',
    onChange: function onChange(newValue) {
      return handleUpdateLayoutSettings('spacing', newValue);
    }
  })), /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Theme",
    options: themes,
    value: containerSettings.theme,
    onChange: function onChange(newValue) {
      return handleUpdateLayoutSettings('theme', newValue);
    }
  })), /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Section ID",
    value: containerSettings.sectionID || '',
    onChange: function onChange(newValue) {
      return handleUpdateLayoutSettings('sectionID', newValue);
    }
  })), /*#__PURE__*/React.createElement(Segment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "CSS class",
    value: containerSettings.className || '',
    onChange: function onChange(newValue) {
      return handleUpdateLayoutSettings('className', newValue);
    }
  }))))));
};
var usePreventWindowUnload = function usePreventWindowUnload(preventDefault) {
  React.useEffect(function () {
    if (!preventDefault) return;
    var handleBeforeUnload = function handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return function () {
      return window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [preventDefault]);
};
var PageBuilder = function PageBuilder(_ref) {
  var initialPage = _ref.page,
    library = _ref.library,
    adminLibrary = _ref.adminLibrary,
    spacings = _ref.spacings,
    themes = _ref.themes,
    buttonStyles = _ref.buttonStyles,
    defaultTheme = _ref.defaultTheme,
    languageSwitcherSettings = _ref.languageSwitcherSettings,
    identifier = _ref.identifier,
    sidebarButtons = _ref.sidebarButtons,
    host = _ref.host,
    onChange = _ref.onChange,
    onSave = _ref.onSave,
    onExit = _ref.onExit;
  var _React$useState = React.useState(initialPage),
    page = _React$useState[0],
    setPage = _React$useState[1];
  var _React$useState2 = React.useState(false),
    dirty = _React$useState2[0],
    setDirty = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    selectedWidget = _React$useState3[0],
    setSelectedWidget = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    reorderOpen = _React$useState4[0],
    setReorderOpen = _React$useState4[1];
  usePreventWindowUnload(dirty);
  if (!adminLibrary) {
    console.warn('No adminLibrary provided to AdminBuilder. ');
  }
  var currentWidget = selectedWidget ? adminLibrary[selectedWidget.component] : null;
  var factory = function factory(widgetName, defaultTheme) {
    var widget = adminLibrary[widgetName];
    var settings = widgetData.defaults(widget);
    if (settings.containerSettings) {
      settings.containerSettings.theme = settings.containerSettings.theme || defaultTheme;
    } else {
      settings.containerSettings = {
        theme: defaultTheme
      };
    }
    return {
      widgetId: randomString(6),
      component: widgetName,
      settings: settings
    };
  };
  var handleAdd = function handleAdd(widgetName, defaultTheme) {
    var widgets = add(page.widgets, factory(widgetName, defaultTheme));
    var newPage = _extends({}, page, {
      widgets: widgets
    });
    setPage(newPage);
    setDirty(true);
    notifyChange(newPage);
  };
  var handleUpdate = function handleUpdate(widget) {
    var widgets = updateFieldById(page.widgets, 'settings', widget.settings, widget.widgetId, 'widgetId');
    var newPage = _extends({}, page, {
      widgets: widgets
    });
    setPage(newPage);
    notifyChange(newPage);
  };
  var handleRemove = function handleRemove(id) {
    var widgets = removeById(page.widgets, id, 'widgetId');
    var newPage = _extends({}, page, {
      widgets: widgets
    });
    setPage(newPage);
    setDirty(true);
    notifyChange(newPage);
  };
  var handleReorder = function handleReorder(widgets) {
    if (page.widgets.map(function (w) {
      return w.widgetId;
    }).join() !== widgets.map(function (w) {
      return w.widgetId;
    }).join()) {
      var newPage = _extends({}, page, {
        widgets: widgets
      });
      setPage(newPage);
      setDirty(true);
      notifyChange(newPage);
    }
  };
  var notifyChange = function notifyChange(page) {
    return onChange(page);
  };
  var handleSave = function handleSave() {
    onSave(page);
    setDirty(false);
  };
  var handlePasteWidget = function handlePasteWidget() {
    var clipboardWidget = JSON.parse(window.localStorage.getItem("clipboard\u2013" + identifier));
    if (!clipboardWidget) return alert('Nothing to paste, yet');
    var newWidget = {
      widgetId: randomString(6),
      component: clipboardWidget.widgetName,
      settings: clipboardWidget.widget.settings
    };
    console.log(newWidget);
    var widgets = add(page.widgets, newWidget);
    var newPage = _extends({}, page, {
      widgets: widgets
    });
    setPage(newPage);
    setDirty(true);
    notifyChange(newPage);
  };
  var handleSaveWidget = function handleSaveWidget(settings) {
    handleUpdate(_extends({}, selectedWidget, {
      settings: settings
    }));
    setDirty(true);
    setSelectedWidget(null);
  };
  var handleClose = function handleClose() {
    setSelectedWidget(null);
  };
  var widgets = page.widgets;
  var sortableWidgets = widgets.map(function (widget) {
    return _extends({}, widget, {
      id: widget.widgetId,
      chosen: false,
      selected: false
    });
  });
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(HostContext.Provider, {
    value: {
      host: host
    }
  }, /*#__PURE__*/React.createElement(LibraryContext.Provider, {
    value: {
      library: library,
      adminLibrary: adminLibrary
    }
  }, /*#__PURE__*/React.createElement(LibraryContext$1.Provider, {
    value: buttonStyles
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: '64px'
    }
  }, reorderOpen && /*#__PURE__*/React.createElement(ReorderDialog, {
    widgets: sortableWidgets,
    onChange: handleReorder,
    onDelete: handleRemove,
    onSelectWidget: setSelectedWidget,
    onClose: function onClose() {
      return setReorderOpen(false);
    }
  }), /*#__PURE__*/React.createElement(AdminSidebar, {
    languageSwitcherSettings: languageSwitcherSettings,
    dirty: dirty,
    buttons: sidebarButtons,
    onSave: handleSave,
    onAddWidget: function onAddWidget(widgetName) {
      return handleAdd(widgetName, defaultTheme);
    },
    onReorderDialog: function onReorderDialog() {
      return setReorderOpen(true);
    },
    onExit: onExit,
    onPasteWidget: handlePasteWidget
  }), /*#__PURE__*/React.createElement(Canvas, {
    widgets: sortableWidgets,
    identifier: identifier,
    onReorder: handleReorder,
    onEdit: setSelectedWidget,
    onRemove: handleRemove
  }), selectedWidget && /*#__PURE__*/React.createElement(SettingsDialog, {
    spacings: spacings,
    themes: themes,
    widget: currentWidget,
    settings: selectedWidget.settings,
    onSave: handleSaveWidget,
    onClose: handleClose
  }))))));
};
PageBuilder.defaultProps = {
  themes: [['none', 'None'], ['light', 'Light'], ['dark', 'Dark']],
  spacings: [['none', 'None'], ['both', 'Both'], ['top', 'Top'], ['bottom', 'Bottom']],
  buttonStyles: ButtonSettings.defaultButtonStyles
};
var ImageInput = function () {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "ImageInput is no longer part of @raketa-cms/raketa-cms. Please use @raketa-cms/raketa-image-input.", ' '), /*#__PURE__*/React.createElement("strong", null, "Update imports"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("code", null, "import { ImageInput } from '@raketa-cms/raketa-image-picker';")));
};
var Img = function Img(_ref) {
  var src = _ref.src,
    variant = _ref.variant,
    className = _ref.className,
    onLoad = _ref.onLoad,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? null : _ref$alt,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    props = _objectWithoutPropertiesLoose(_ref, ["src", "variant", "className", "onLoad", "alt", "title"]);
  if (!src) {
    console.warn("WARNING: Image with src null or undefined will not be rendered: " + variant + " " + (className || ''));
    return null;
  }
  if (!variant) {
    console.warn('WARNING: You are using an <Img /> tag without a variant. Unoptimized original is used as a fallback, but you need to specify a size variant');
  }
  var imgVariant = variant ? variant : 'original';
  var imgAlt = alt !== null ? alt : src.alt;
  var imgTitle = title !== null ? title : '';
  if (typeof src === 'object' && !('name' in src)) console.warn("WARNING: Image with empty {}: " + imgVariant + " " + (className || ''));
  if (typeof src === 'object' && 'name' in src && (src.name.includes('.svg') || src.name.includes('.gif'))) return /*#__PURE__*/React.createElement("img", _extends({
    src: src.urls.original,
    alt: imgAlt !== null ? imgAlt : src.name,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  if (typeof src === 'object' && 'name' in src) return /*#__PURE__*/React.createElement("img", _extends({
    src: src.urls[imgVariant],
    alt: imgAlt !== null ? imgAlt : src.name,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  if (typeof src === 'string') return /*#__PURE__*/React.createElement("img", _extends({
    src: src,
    alt: src,
    className: className,
    onLoad: onLoad,
    title: imgTitle
  }, props));
  return null;
};
function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-weight: 700;\n"]);
  _templateObject9$1 = function _templateObject9() {
    return data;
  };
  return data;
}
function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);
  _templateObject8$1 = function _templateObject8() {
    return data;
  };
  return data;
}
function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  padding: 8px;\n"]);
  _templateObject7$1 = function _templateObject7() {
    return data;
  };
  return data;
}
function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1;\n  padding: 0;\n"]);
  _templateObject6$1 = function _templateObject6() {
    return data;
  };
  return data;
}
function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border-bottom: 1px solid ", ";\n  padding: 8px;\n  background-color: #efefef;\n"]);
  _templateObject5$2 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-bottom: ", ";\n  border: 1px solid ", ";\n  border-radius: 5px;\n"]);
  _templateObject4$3 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  width: 16px;\n  padding-right: 8px;\n  cursor: move;\n\n  & > img {\n    width: 16px;\n  }\n"]);
  _templateObject3$3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-bottom: ", ";\n"]);
  _templateObject2$6 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-bottom: ", ";\n"]);
  _templateObject$9 = function _templateObject() {
    return data;
  };
  return data;
}
var Handle = function Handle(props) {
  return /*#__PURE__*/React.createElement(HandleWrapper, {
    "data-drag": true
  }, /*#__PURE__*/React.createElement("img", _extends({}, props, {
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItbW9yZS12ZXJ0aWNhbCI+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMSI+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSI1IiByPSIxIj48L2NpcmNsZT48Y2lyY2xlIGN4PSIxMiIgY3k9IjE5IiByPSIxIj48L2NpcmNsZT48L3N2Zz4="
  })));
};
var IconDelete = function IconDelete() {
  return /*#__PURE__*/React.createElement("img", {
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItdHJhc2giPjxwb2x5bGluZSBwb2ludHM9IjMgNiA1IDYgMjEgNiI+PC9wb2x5bGluZT48cGF0aCBkPSJNMTkgNnYxNGEyIDIgMCAwIDEtMiAySDdhMiAyIDAgMCAxLTItMlY2bTMgMFY0YTIgMiAwIDAgMSAyLTJoNGEyIDIgMCAwIDEgMiAydjIiPjwvcGF0aD48L3N2Zz4=",
    style: {
      width: '16px'
    }
  });
};
var IconMaximize = function IconMaximize() {
  return /*#__PURE__*/React.createElement("img", {
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLWNoZXZyb24tZG93biI+PHBvbHlsaW5lIHBvaW50cz0iNiA5IDEyIDE1IDE4IDkiPjwvcG9seWxpbmU+PC9zdmc+",
    style: {
      width: '16px'
    }
  });
};
var IconMinimize = function IconMinimize() {
  return /*#__PURE__*/React.createElement("img", {
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLWNoZXZyb24tdXAiPjxwb2x5bGluZSBwb2ludHM9IjE4IDE1IDEyIDkgNiAxNSI+PC9wb2x5bGluZT48L3N2Zz4=",
    style: {
      width: '16px'
    }
  });
};
var ListWrapper = styled.div(_templateObject$9(), reset, function (props) {
  return props.theme.font.base;
});
var AddButtonWrapepr = styled.div(_templateObject2$6(), reset, function (props) {
  return props.theme.font.base;
});
var HandleWrapper = styled.div(_templateObject3$3());
var ItemWrapper = styled.div(_templateObject4$3(), reset, function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.colors.gray;
});
var TitleBar = styled.div(_templateObject5$2(), reset, function (props) {
  return props.theme.colors.gray;
});
var TitleWrapper = styled.button(_templateObject6$1(), buttonReset);
var ContentWrapper = styled.div(_templateObject7$1(), reset);
var ListButton = styled.button(_templateObject8$1(), buttonReset);
var Title = styled.span(_templateObject9$1(), reset);
var extractPrimaryField = function extractPrimaryField(primaryField, item, idx) {
  if (!primaryField) {
    return "Item " + (idx + 1);
  }
  var keys = primaryField.split('.');
  if (keys.length === 1) {
    return item[primaryField];
  }
  return primaryField.split('.').reduce(function (acc, key) {
    var newValue = acc && acc[key] || '';
    return newValue;
  }, item);
};
var Item = function Item(_ref) {
  var idx = _ref.idx,
    items = _ref.items,
    item = _ref.item,
    alwaysOpened = _ref.alwaysOpened,
    primaryField = _ref.primaryField,
    template = _ref.template,
    handleRemove = _ref.handleRemove,
    handleChangeField = _ref.handleChangeField,
    listItem = _ref.listItem;
  var _React$useState = React.useState(alwaysOpened),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  return /*#__PURE__*/React.createElement(ItemWrapper, null, /*#__PURE__*/React.createElement(TitleBar, null, /*#__PURE__*/React.createElement(Handle, null), /*#__PURE__*/React.createElement(TitleWrapper, {
    type: "button",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React.createElement(Title, null, extractPrimaryField(primaryField, item, idx)), !alwaysOpened && /*#__PURE__*/React.createElement(ListButton, {
    type: "button"
  }, open ? /*#__PURE__*/React.createElement(IconMinimize, null) : /*#__PURE__*/React.createElement(IconMaximize, null))), /*#__PURE__*/React.createElement("div", null, (template || !template && items.length !== 1) && /*#__PURE__*/React.createElement(ListButton, {
    type: "button",
    danger: true,
    onClick: function onClick() {
      return handleRemove(idx);
    }
  }, /*#__PURE__*/React.createElement(IconDelete, null)))), (alwaysOpened || open) && /*#__PURE__*/React.createElement(ContentWrapper, null, listItem(item, function (field, value) {
    return handleChangeField(idx, field, value);
  }, idx)));
};
var List = function List(_ref2) {
  var label = _ref2.label,
    defaultItems = _ref2.items,
    listItem = _ref2.listItem,
    template = _ref2.template,
    primaryField = _ref2.primaryField,
    onChangeList = _ref2.onChangeList,
    _ref2$itemsAlwaysOpen = _ref2.itemsAlwaysOpen,
    itemsAlwaysOpen = _ref2$itemsAlwaysOpen === void 0 ? false : _ref2$itemsAlwaysOpen;
  var _React$useState2 = React.useState(defaultItems),
    items = _React$useState2[0],
    setItems = _React$useState2[1];
  var factory = function factory(template) {
    if (!template) throw new Error('Template not specified for this list');
    return Object.assign({}, template, {
      id: randomId()
    });
  };
  var handleChangeField = function handleChangeField(idx, field, value) {
    var newItems = updateFieldByIndex(items, field, value, idx);
    setItems(newItems);
    notifyChange(newItems);
  };
  var notifyChange = function notifyChange(items) {
    onChangeList('list', items);
  };
  var handleAdd = function handleAdd() {
    var newItems = add(items, factory(template));
    setItems(newItems);
    notifyChange(newItems);
  };
  var handleAddAtBeggining = function handleAddAtBeggining() {
    var newItems = addAtBeggining(items, factory(template));
    setItems(newItems);
    notifyChange(newItems);
  };
  var handleReorder = function handleReorder(items) {
    setItems(items);
    notifyChange(items);
  };
  var handleRemove = function handleRemove(idx) {
    if (!template && items.length === 1) return;
    var newItems = removeByIndex(items, idx);
    setItems(newItems);
    notifyChange(newItems);
  };
  if (!primaryField) console.warn('No primaryField provided for a list', items);
  if (!label) console.warn('No label provided for a list', items);
  return /*#__PURE__*/React.createElement(ListWrapper, null, label && /*#__PURE__*/React.createElement(H, {
    size: "base",
    style: {
      fontWeight: 700
    }
  }, label), items.length === 0 && /*#__PURE__*/React.createElement(P, null, "There are no items yet."), items.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddButtonWrapepr, null, /*#__PURE__*/React.createElement(Button$1, {
    type: "button",
    variant: "success",
    onClick: handleAddAtBeggining
  }, "Add item")), /*#__PURE__*/React.createElement(ReactSortable, {
    list: items,
    setList: handleReorder,
    handle: "[data-drag]",
    direction: "horizontal",
    dragoverBubble: true
  }, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.id,
      "data-id": idx,
      idx: idx,
      items: items,
      item: item,
      alwaysOpened: itemsAlwaysOpen,
      primaryField: primaryField,
      template: template,
      handleRemove: handleRemove,
      handleChangeField: handleChangeField,
      listItem: listItem
    });
  }))), /*#__PURE__*/React.createElement(Button$1, {
    type: "button",
    variant: "success",
    onClick: handleAdd
  }, "Add item"));
};
List.defaultProps = {
  items: []
};
var containerClass = function (className, containerSettings) {
  var classes = [className];
  if (containerSettings && containerSettings.spacing !== 'none' && containerSettings.spacing !== undefined) classes.push("spacing-" + containerSettings.spacing);
  if (containerSettings && containerSettings.theme !== 'none' && containerSettings.theme !== undefined) classes.push(containerSettings.theme + "-bg");
  if (containerSettings && containerSettings.className) classes.push(containerSettings.className);
  return classes.filter(Boolean).join(' ');
};
var Container = function Container(_ref) {
  var settings = _ref.settings,
    className = _ref.className,
    children = _ref.children;
  var props = {};
  props.className = containerClass(className, settings);
  if (settings && settings.sectionID) props.id = settings.sectionID;
  return /*#__PURE__*/React.createElement("div", props, children);
};
Container.defaultProps = {
  className: '',
  id: ''
};
var VimeoEmbed = function VimeoEmbed(_ref) {
  var videoId = _ref.videoId,
    autoplay = _ref.autoplay;
  return /*#__PURE__*/React.createElement("iframe", {
    frameBorder: "0",
    allowFullScreen: "0",
    src: "https://player.vimeo.com/video/" + videoId + "?color=ffffff&title=0&byline=0&portrait=0&autoplay=" + (autoplay === true ? '1' : '0'),
    className: "content",
    allow: "autoplay"
  });
};
var YoukuEmbed = function YoukuEmbed(_ref2) {
  var videoId = _ref2.videoId,
    autoplay = _ref2.autoplay;
  return /*#__PURE__*/React.createElement("iframe", {
    height: "0",
    width: "0",
    src: "https://player.youku.com/embed/" + videoId + "?autoplay=" + (autoplay === true ? '1' : '0'),
    frameBorder: "0",
    allowFullScreen: true,
    className: "content",
    allow: "autoplay"
  });
};
var YouTubeEmbed = function YouTubeEmbed(_ref3) {
  var videoId = _ref3.videoId,
    autoplay = _ref3.autoplay;
  return /*#__PURE__*/React.createElement("iframe", {
    frameBorder: "0",
    allowFullScreen: true,
    src: "https://youtube.com/embed/" + videoId + "?autoplay=" + (autoplay === true ? '1' : '0'),
    className: "content",
    allow: "autoplay"
  });
};
var YouTubeNoCookieEmbed = function YouTubeNoCookieEmbed(_ref4) {
  var videoId = _ref4.videoId,
    autoplay = _ref4.autoplay;
  return /*#__PURE__*/React.createElement("iframe", {
    frameBorder: "0",
    allowFullScreen: true,
    src: "https://www.youtube-nocookie.com/embed/" + videoId + "?autoplay=" + (autoplay === true ? '1' : '0'),
    className: "content",
    allow: "autoplay"
  });
};
var WistiaEmbed = function WistiaEmbed(_ref5) {
  var videoId = _ref5.videoId,
    autoplay = _ref5.autoplay;
  return /*#__PURE__*/React.createElement("iframe", {
    frameBorder: "0",
    allowFullScreen: true,
    src: "https://fast.wistia.net/embed/iframe/" + videoId + (autoplay ? '?autoPlay=true' : ''),
    className: "content",
    allow: "autoplay"
  });
};
var videoType = function videoType(url) {
  if (url.includes('youtu')) return 'youtube';
  if (url.includes('vimeo')) return 'vimeo';
  if (url.includes('youku')) return 'youku';
  if (url.includes('wistia')) return 'wistia';
};
var youtubeId = function youtubeId(url) {
  var matches = url.match(/(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'>]+)/);
  return matches !== '' && matches !== null ? matches[5] : '';
};
var vimeoId = function vimeoId(url) {
  var matches = url.match(/http(s?):\/\/(www\.)?vimeo\.com\/(\d+)($|\/)/);
  return matches !== '' && matches !== null ? matches[3] : '';
};
var youkuId = function youkuId(url) {
  var matches = url.match(/http(s?):\/\/v\.youku\.com\/v_show\/id_([A-Za-z0-9=]+)\.html/);
  return matches !== '' && matches !== null ? matches[2] : '';
};
var wistiaId = function wistiaId(url) {
  var matches = url.match(/http(s?):\/\/fast\.wistia\.net\/embed\/iframe\/(.*)($|\?)/);
  return matches !== '' && matches !== null ? matches[2] : '';
};
var videoId = function videoId(url) {
  if (videoType(url) === 'youtube') return youtubeId(url);
  if (videoType(url) === 'vimeo') return vimeoId(url);
  if (videoType(url) === 'youku') return youkuId(url);
  if (videoType(url) === 'wistia') return wistiaId(url);
};
var VideoComponentType = function VideoComponentType(vType, noCookieDomains) {
  var components = {
    youtube: YouTubeEmbed,
    vimeo: VimeoEmbed,
    youku: YoukuEmbed,
    wistia: WistiaEmbed
  };
  var noCookiesComponents = {
    youtube: YouTubeNoCookieEmbed,
    vimeo: VimeoEmbed,
    youku: YoukuEmbed,
    wistia: WistiaEmbed
  };
  if (noCookieDomains) {
    return noCookiesComponents[vType];
  } else {
    return components[vType];
  }
};
var EmbeddedVideo = function EmbeddedVideo(_ref6) {
  var videoUrl = _ref6.videoUrl,
    _ref6$autoplay = _ref6.autoplay,
    autoplay = _ref6$autoplay === void 0 ? false : _ref6$autoplay,
    _ref6$noCookieDomains = _ref6.noCookieDomains,
    noCookieDomains = _ref6$noCookieDomains === void 0 ? false : _ref6$noCookieDomains;
  var vType = videoType(videoUrl);
  var vId = videoId(videoUrl);
  var VideoComponent = VideoComponentType(vType, noCookieDomains);
  if (VideoComponent) {
    return /*#__PURE__*/React.createElement(VideoComponent, {
      videoId: vId,
      autoplay: autoplay
    });
  }
  return null;
};
var MediaManager = /*#__PURE__*/function () {
  function MediaManager() {
    console.warn('MediaManager is no longer part of @raketa-cms/raketa-cms. Please use @raketa-cms/raketa-image-input. ');
  }
  var _proto = MediaManager.prototype;
  _proto.findAll = function findAll(callback, params) {};
  _proto.uploadFile = function uploadFile(file, callback) {};
  _proto.update = function update(image, params, callback) {};
  _proto.destroy = function destroy(image, callback) {};
  return MediaManager;
}();
var ListInput = function ListInput(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(List, props));
};
var imgageSrc = function imgageSrc(src, variant) {
  if (typeof src === 'object' && !('name' in src)) console.warn("WARNING: Image with empty {}: " + variant);
  if (typeof src === 'object' && 'name' in src && (src.name.includes('.svg') || src.name.includes('.gif'))) return src.urls.original;
  if (typeof src === 'object' && 'name' in src) return src.urls[variant];
  if (typeof src === 'string') return src;
  return null;
};
var Button = function Button(_ref) {
  var settings = _ref.settings,
    className = _ref.className;
  var button_id = settings.button_id,
    button_label = settings.button_label,
    button_link = settings.button_link,
    button_target = settings.button_target,
    button_type = settings.button_type,
    follow_link = settings.follow_link;
  var buttonClass;
  if (button_type === 'accented') buttonClass = 'btn-active-dark';
  if (button_type === 'regular') buttonClass = 'btn-passive-light';
  if (button_type === 'link') buttonClass = 'btn-text';
  if (className) buttonClass = buttonClass + " " + className;
  return /*#__PURE__*/React.createElement("a", {
    href: button_link,
    className: buttonClass,
    id: button_id,
    target: button_target,
    rel: follow_link === 'no-follow' ? 'nofollow' : ''
  }, button_label);
};
function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  margin-bottom: 0;\n\n  & + div {\n    margin-top: ", ";\n  }\n"]);
  _templateObject4$4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: ", ";\n  font-size: ", ";\n  text-transform: uppercase;\n  font-weight: bold;\n"]);
  _templateObject3$4 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n\n  & > div {\n    width: 33.33%;\n    padding-right: ", ";\n\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n\n  &:last-child {\n    & > div {\n      margin-bottom: 0;\n    }\n  }\n"]);
  _templateObject2$7 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  margin-right: ", ";\n  background-size: 100% auto;\n  background-repeat: none;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItc2xpZGVycyI+PGxpbmUgeDE9IjQiIHkxPSIyMSIgeDI9IjQiIHkyPSIxNCI+PC9saW5lPjxsaW5lIHgxPSI0IiB5MT0iMTAiIHgyPSI0IiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjIxIiB4Mj0iMTIiIHkyPSIxMiI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjgiIHgyPSIxMiIgeTI9IjMiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIyMSIgeDI9IjIwIiB5Mj0iMTYiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIxMiIgeDI9IjIwIiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxIiB5MT0iMTQiIHgyPSI3IiB5Mj0iMTQiPjwvbGluZT48bGluZSB4MT0iOSIgeTE9IjgiIHgyPSIxNSIgeTI9IjgiPjwvbGluZT48bGluZSB4MT0iMTciIHkxPSIxNiIgeDI9IjIzIiB5Mj0iMTYiPjwvbGluZT48L3N2Zz4=);\n\n}"]);
  _templateObject$a = function _templateObject() {
    return data;
  };
  return data;
}
var SettingsIcon$1 = styled.span(_templateObject$a(), function (props) {
  return props.theme.font.base;
}, function (props) {
  return props.theme.font.base;
}, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
});
var ThreeColumns$1 = styled.div(_templateObject2$7(), reset, function (props) {
  return props.theme.font.base;
});
var FormSectionTitle$1 = styled.h6(_templateObject3$4(), reset, function (props) {
  return "calc(" + props.theme.font.base + " / 2)";
}, function (props) {
  return props.theme.font.small;
});
var ButtonControl$1 = styled.div(_templateObject4$4(), reset, function (props) {
  return props.theme.font.base;
});
var mergeSettings$1 = function mergeSettings(settings, key, value) {
  var _Object$assign;
  return Object.assign({}, settings, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
};
var LinkSettings = function LinkSettings(_ref) {
  var label = _ref.label,
    hint = _ref.hint,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(ButtonControl$1, null, /*#__PURE__*/React.createElement(FormSectionTitle$1, null, /*#__PURE__*/React.createElement(SettingsIcon$1, null), " ", label), /*#__PURE__*/React.createElement(ThreeColumns$1, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: value.label,
    onChange: function onChange(label) {
      return _onChange(mergeSettings$1(value, 'label', label));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Link",
    value: value.link,
    onChange: function onChange(link) {
      return _onChange(mergeSettings$1(value, 'link', link));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "ID",
    value: value.id,
    onChange: function onChange(id) {
      return _onChange(mergeSettings$1(value, 'id', id));
    }
  })), /*#__PURE__*/React.createElement(ThreeColumns$1, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "CSS Class",
    value: value.className,
    onChange: function onChange(className) {
      return _onChange(mergeSettings$1(value, 'className', className));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Target",
    options: [['_self', 'Self'], ['_blank', 'New Tab']],
    value: value.target,
    onChange: function onChange(target) {
      return _onChange(mergeSettings$1(value, 'target', target));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Follow Link",
    options: [['follow', 'Follow'], ['nofollow', 'No Follow']],
    value: value.rel,
    onChange: function onChange(rel) {
      return _onChange(mergeSettings$1(value, 'rel', rel));
    }
  })), hint ? /*#__PURE__*/React.createElement(Hint, null, hint) : '');
};
var DEFAULTS$1 = {
  label: 'link',
  link: '#',
  id: '',
  className: '',
  target: '_self',
  rel: 'follow'
};
LinkSettings.defaultProps = {
  label: 'Link  ',
  value: DEFAULTS$1
};
LinkSettings.defaults = DEFAULTS$1;
var Link = function Link(_ref) {
  var settings = _ref.settings,
    children = _ref.children,
    className = _ref.className;
  var id = settings.id,
    label = settings.label,
    link = settings.link,
    target = settings.target,
    rel = settings.rel;
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    className: [settings.className, className].join(' '),
    id: id || '',
    target: target,
    rel: rel
  }, children || label);
};
var RaketaUIProvider = function RaketaUIProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children);
};
RaketaUIProvider.defaultProps = {
  theme: theme
};
export { Button, ButtonSettings, Container, Dialog, EmbeddedVideo, ImageInput, ImagePicker, Img, Link, LinkSettings, List, ListInput, MediaManager, PageBuilder, RaketaUIProvider, RichText, SelectMenu, TextArea, TextInput, imgageSrc as imageSrc };